import { post } from '@/lib/api';
import type { SupplierProfile } from './profile';

export interface AuthResponse {
  access_token: string;
  refresh_token: string;
  token_type: 'Bearer';
  supplier: SupplierProfile;
}

export interface RegisterInput {
  email: string;
  password: string;
  name: string;
  phone?: string;
  city: string;
}

export const supplierRegister = (input: RegisterInput) =>
  post<AuthResponse>('/auth/register', input);

export const supplierLogin = (email: string, password: string) =>
  post<AuthResponse>('/auth/login', { email, password });
